import { LOGO_URL, SIDEBAR_BRAND_BANNER } from '@/data/blackGoldSite'

export const DEFAULT_CURRENCY = '₩'
export const DEFAULT_SITE_NAME = '헬퍼 카지노'

function parseSiteImg (siteInfo) {
  const value = siteInfo && siteInfo.site_img
  if (value && typeof value === 'object') {
    return {
      logo: value.logo != null ? String(value.logo).trim() : '',
      banner: value.banner != null ? String(value.banner).trim() : ''
    }
  }

  const raw = value != null ? String(value).trim() : ''
  if (!raw) {
    return { logo: '', banner: '' }
  }

  if (raw.startsWith('{')) {
    try {
      const parsed = JSON.parse(raw)
      return {
        logo: parsed && parsed.logo != null ? String(parsed.logo).trim() : '',
        banner: parsed && parsed.banner != null ? String(parsed.banner).trim() : ''
      }
    } catch (e) {
      return { logo: raw, banner: '' }
    }
  }

  return { logo: raw, banner: '' }
}

export function getSiteLogoUrl (siteInfo) {
  const { logo } = parseSiteImg(siteInfo)
  return logo
}

export function resolveSiteLogoUrl (siteInfo) {
  return getSiteLogoUrl(siteInfo) || LOGO_URL
}

export function resolveSiteBannerUrl (siteInfo) {
  const { banner } = parseSiteImg(siteInfo)
  return banner || SIDEBAR_BRAND_BANNER
}

export function getTelegramInquiryBannerUrl (locale) {
  const suffix = String(locale || 'ko').toLowerCase() === 'ko' ? 'ko' : 'en'
  return `/assets/images/telegram-inquiry_${suffix}.png`
}

export function resolveSiteCurrency (siteInfo) {
  const raw = siteInfo && siteInfo.currency != null
    ? String(siteInfo.currency).trim()
    : ''
  return raw || DEFAULT_CURRENCY
}

export function resolveSiteName (siteInfo) {
  const raw = siteInfo && siteInfo.name != null
    ? String(siteInfo.name).trim()
    : ''
  return raw || DEFAULT_SITE_NAME
}

export function applySiteDocumentTitle (siteInfo) {
  if (typeof document === 'undefined') return
  const raw = siteInfo && siteInfo.name != null
    ? String(siteInfo.name).trim()
    : ''
  document.title = raw
}
